import { clsx } from 'clsx';

import DraggableListItem from './DraggableListItem';

import type { IDraggableListProps } from './interfaces/IDraggableList';

import styles from './scss/DraggableList.module.scss';

function DraggableList<T = unknown>({
  items,
  onMove,
  renderItem,
  keyExtractor,
  className = '',
  itemClassName = '',
  itemType = 'DRAGGABLE_ITEM',
  showNumber = false,
}: IDraggableListProps<T>) {
  return (
    <div className={clsx(styles.draggableList, className)}>
      {items.map((item, index) => (
        <DraggableListItem
          key={keyExtractor(item, index)}
          index={index}
          onMove={onMove}
          className={itemClassName}
          itemType={itemType}
          showNumber={showNumber}
        >
          {renderItem(item, index)}
        </DraggableListItem>
      ))}
    </div>
  );
}

export default DraggableList;
